import { Field } from '@app/common/configurable-wizards/types';

import { findField } from './subFieldsFinder';

/**
 * Shift specific field to new position.
 */
export const shiftField = (
  fields: Field[],
  predicate: (item: Field) => boolean,
  to: number,
) => {
  // find field index
  const fieldIndex = fields.findIndex((subField) => findField(
    [subField as Field],
    (item) => (predicate(item) ? item : null),
  ));

  // move field to specified position
  if (fieldIndex !== -1 && fieldIndex !== to) {
    const result = [...fields];
    result.splice(to, 0, ...result.splice(fieldIndex, 1));

    return result;
  }

  return fields;
};
